export enum BatchStatus {
    Open,
    Close
}

export class Batch {
    id: number;
    number: string;
    status: BatchStatus;
    notes?: string;
    isDefault: boolean;
    locationId: number;

    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);
        }
    }
}